import { render, staticRenderFns } from "./WithholdingTaxCertificatePDF.vue?vue&type=template&id=b6790c12&"
import script from "./WithholdingTaxCertificatePDF.vue?vue&type=script&lang=js&"
export * from "./WithholdingTaxCertificatePDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VLayout,
})
